module.exports = __webpack_public_path__ + "img/PG.780d7148.png";